import React, { useState } from 'react';
import { Toolbar, AppBar, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { darkGrey, offWhite } from '../../../app/theme';
import ExternalLinkModal from '../ExternalLinkModal/ExternalLinkModal';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none',
    backgroundColor: offWhite,
    height: 70,
  },
  topToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 70,
    color: darkGrey,
  },
  copyright: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0,
    paddingLeft: 41,
  },
  rightSide: {
    display: 'flex',
    paddingRight: 37,
  },
  rightSideButtons: {
    textTransform: 'none',
    marginLeft: 16,
    fontSize: 16,
    fontWeight: 500,
  },
}));

const TrainingFooter = (): JSX.Element => {
  const classes = useStyles();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalUrl, setModalUrl] = useState<string>('');

  const handleClickPrivacy = () => {
    setModalUrl('https://www.blueearthdiagnostics.com/privacy-policy/');
    setIsModalOpen(true);
  };
  const handleClickBlueEarth = () => {
    setModalUrl('http://blueearthdiagnostics.com/');
    setIsModalOpen(true);
  };
  const handleClickContactUs = () => {
    // TODO: When not logged in, this should display a different modal (CAX-78)
    setModalUrl('https://www.blueearthdiagnostics.com/contact/');
    setIsModalOpen(true);
  };

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar className={classes.topToolbar}>
        {/* Left side */}
        <div>
          <Typography className={classes.copyright}>
            &copy;2023 Blue Earth Diagnostics, Inc. All rights reserved.
          </Typography>
        </div>

        {/* Right side */}
        <div className={classes.rightSide}>
          <Button
            className={classes.rightSideButtons}
            href="/termsconditions"
            target="_blank"
            rel="noreferrer"
            color="inherit"
          >
            Terms & Conditions
          </Button>
          <Button className={classes.rightSideButtons} onClick={handleClickPrivacy} color="inherit">
            Privacy
          </Button>
          <Button className={classes.rightSideButtons} onClick={handleClickBlueEarth} color="inherit">
            BlueEarthDiagnostics.com
          </Button>
          <Button className={classes.rightSideButtons} onClick={handleClickContactUs} color="inherit">
            Contact Us
          </Button>
        </div>
      </Toolbar>
      <ExternalLinkModal
        url={modalUrl}
        isOpen={isModalOpen}
        handleModalOpen={(isOpen: boolean) => setIsModalOpen(isOpen)}
      />
    </AppBar>
  );
};

export default TrainingFooter;
